// @ts-nocheck
import * as React from 'react';
import $ from 'jquery';

import batterycritical from '../images/battery-critical.svg';
import batterylow from '../images/battery-low.svg';
import batterynormal from '../images/battery-normal.svg';

import PlugSolid from '../images/PlugSolid.svg';
import UnPlug from '../images/Unplug.svg';

import TripInprogress from '../images/Status/RouteDeviation/TripInprogress.png';
import TripCompletedDeviation from '../images/Status/RouteDeviation/TripCompletedDeviation.png';
import TripCompleted from '../images/Status/RouteDeviation/TripCompleted.png';
import TripProblemetic from '../images/Status//RouteDeviation/TripProblemetic.png';
import TripPending from '../images/Status/RouteDeviation/TripPending.png';
import TripDeleted from '../images/Status/RouteDeviation/TripDeleted.png';
import TripCancelDeviation from '../images/Status/RouteDeviation/TripCancelDeviation.png';
import TripCancel from '../images/Status/RouteDeviation/TripCancel.png';

import RSSIUNK from '../images/RSSI/RSSI_UNK.png';
import RSSI1 from '../images/RSSI/RSSI_1.png';
import RSSI2 from '../images/RSSI/RSSI_2.png';
import RSSI3 from '../images/RSSI/RSSI_3.png';
import RSSI4 from '../images/RSSI/RSSI_4.png';
import RSSI5 from '../images/RSSI/RSSI_5.png';

import GroupChat from '../images/GroupChat.png';

export class ChassisCellRenderer extends React.Component {
    constructor(props: any) {
        super(props);
    }

    static PwrStateFormatter(params) {
        if (params.data != null && params.data != undefined) {
            if (params.data.PWR != null && params.data.PWR != undefined) {

                if (params.data.PWR.toString().toUpperCase().trim() == "A") {
                    return <span className="pwr_grid_icon" title="Powered"><img src={PlugSolid}></img></span>;
                }
                else if (params.data.PWR.toString().toUpperCase().trim() == "B") {
                    return <span className="pwr_grid_icon" title="On Battery"><img src={UnPlug}></img></span>;
                }                
            }
        }
        //return '-NA-';
        return "-NA-";
    }

    static BatteryStatusFormatter(params) {
        if (params.data != null && params.data != undefined) {
            if (params.data.ChassisBatteryStatus != null && params.data.ChassisBatteryStatus != undefined) {
                if (params.data.ChassisBatteryStatus.toString().toUpperCase().trim() == "C") {
                    return <span className="pwr_grid_icon"><img src={batterycritical}></img></span>;
                }
                else if (params.data.ChassisBatteryStatus.toString().toUpperCase().trim() == "L") {
                    return <span className="pwr_grid_icon"><img src={batterylow}></img></span>;
                }
                else if (params.data.ChassisBatteryStatus.toString().toUpperCase().trim() == "N") {
                    return <span className="pwr_grid_icon"><img src={batterynormal}></img></span>;
                }
            }
        }
        return '-NA-';
    }

    static TripstatusIndicator(params) {
        var deviationFlg = '';
        if (params.value != null && params.value != undefined && params.value != '' && params.value != '-NA-') {

            //var imageSrc = '';
            var valueString = params.value.toString();
            var arrList = valueString.split(':');
            if (arrList.length == 2) {
                var cLogStatusvalue = arrList[0];
                deviationFlg = arrList[1];
                switch (cLogStatusvalue.toUpperCase().trim()) {
                    case 'A':
                        //imageSrc = TripInprogress;
                        return <span className="reefer-alert"><img src={TripInprogress}></img></span>;
                    //break;
                    case 'C':
                        if (deviationFlg == "True")
                            //imageSrc = TripCompletedDeviation; /* WI19591 checking Trip is deviated */
                            return <span className="reefer-alert"><img src={TripCompletedDeviation}></img></span>;
                        else
                            //imageSrc = TripCompleted;
                            return <span className="reefer-alert"><img src={TripCompleted}></img></span>;
                    //break;
                    case 'D':
                        //imageSrc = TripProblemetic;
                        return <span className="reefer-alert"><img src={TripProblemetic}></img></span>;
                    //break;
                    case 'P':
                        //imageSrc = TripPending;
                        return <span className="reefer-alert"><img src={TripPending}></img></span>;
                    //break;
                    case 'R':
                        //imageSrc = TripDeleted;
                        return <span className="reefer-alert"><img src={TripDeleted}></img></span>;
                    //break;
                    case 'X':
                        if (deviationFlg == "True")
                            //imageSrc = TripCancelDeviation; /* WI19591 checking Trip is deviated */
                            return <span className="reefer-alert"><img src={TripCancelDeviation}></img></span>;
                        else
                            //imageSrc = TripCancel;
                            return <span className="reefer-alert"><img src={TripCancel}></img></span>;
                    //break;
                    default:
                        break;

                }
            }

            return <span className="reefer-alert"></span>;

        }
        return <span className="reefer-alert"></span>;
    }

    static RSSITypeFormatter(params) {
        var imageSrc = "";
        if (params.data != null && params.data != undefined) {//WI-21812:For Unknown RSSI Id image is not showing
            if (params.data.RSSI != null && params.data.RSSI != undefined) {
                if (params.data.RSSI == 0)
                    imageSrc = RSSIUNK;
                else if (params.data.RSSI <= -111)
                    imageSrc = RSSI1;
                else if (params.data.RSSI >= -110 && params.data.RSSI <= -100)
                    imageSrc = RSSI2;
                else if (params.data.RSSI >= -99 && params.data.RSSI <= -88)
                    imageSrc = RSSI3;
                else if (params.data.RSSI >= -87 && params.data.RSSI <= -76)
                    imageSrc = RSSI4;
                else if (params.data.RSSI >= -75)
                    imageSrc = RSSI5;
                else
                    imageSrc = RSSIUNK;
            }
            else
                imageSrc = RSSIUNK;//WI-21812:For Unknown RSSI Id image is not showing
        }
        return <span className="reefer-alert"><img src={imageSrc}></img></span>;

    }

    static CommentExistsFormatter(params) {

        if (params.value != null && params.value != undefined && params.value != '-NA-') {
            if (params.value == 0) {
                return <span className="Trip-edit"><img src={GroupChat}></img></span>;
            }
            else
                return "-NA-";
        }
        return "-NA-";
    }

    static GPSCoordsFormatter(params) {
        if (params.value != null && params.value != '-1000') {
            if (params.data != null && params.data != undefined && params.data != '') {
                if (params.data.DeviceType != null && params.data.DeviceType != undefined && (params.data.DeviceType.toString().toUpperCase().trim() == "GT1200" || params.data.DeviceType.toString().toUpperCase().trim() == "GT1020" || params.data.DeviceType.toString().toUpperCase().trim() == "GT1030")) {
                    if (params.value != null && params.value != '-1000')
                        return params.value;
                    else
                        return '-NA-';
                }
                else if (params.data.GPSLatitude != 0 && params.data.GPSLongitude != 0 && (params.data.GPSLockState == null || params.data.GPSLockState == '' || params.data.GPSLockState.toUpperCase() != "LOCKED")) {
                    if (params.value != null && params.value != '-1000') {
                        //params.value = <i> {params.value}</i>;
                        //params.value = <p style={"color:#736F6E"} ><i> {params.value}</i></p>;
                        var pCss = {
                            'color': '#736F6E'
                        };
                        return <p style={pCss} ><i> {params.value}</i></p>;
                    }
                    else
                        return '-NA-';
                }
                else if (params.data.GPSCoords != null && params.data.GPSCoords != undefined && params.data.GPSCoords.toString().trim() == "") {
                    return '-NA-';
                }
                else
                    return params.value;
            }
        }
        else
            return '-NA-';
    }

    static StringTypeValueFormatter(params) {
        if (params.value != "-NA-") {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }

    static StringTypeFormatter(params) {
        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';

    }

    static StringTypeFormatterFor3P(params) {
        if (params.value != null && params.value != "null" && params.value != undefined && params.value != '' && params.value != '-NA-') {
            if (params.value === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName)
                return '-NA-';
            else
                return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }

    //Grouping starts from here

    static TripStatusFormatterGrouping(param) {
        var deviationFlg = '';
        if (param != null && param != undefined) {
            var valueString = param.toString();
            var arrList = valueString.split(':');
            if (arrList.length == 2) {
                var cLogStatusvalue = arrList[0];
                deviationFlg = arrList[1];
                switch (cLogStatusvalue.toUpperCase().trim()) {
                    case 'A':
                        return <div><span className="reefer-alert"><img src={TripInprogress} title="In Progress"></img></span><span className='ps-1'> In Progress</span></div>;
                    case 'C':
                        if (deviationFlg == "True")
                            return <div><span className="reefer-alert"><img src={TripCompletedDeviation} title="Completed Deviation"></img></span><span className='ps-1'> Completed Deviation</span></div>;
                        else
                            return <div><span className="reefer-alert"><img src={TripCompleted} title="Completed"></img></span><span className='ps-1'> Completed</span></div>;

                    case 'D':
                        return <div><span className="reefer-alert"><img src={TripProblemetic} title="Problemetic"></img></span><span className='ps-1'> Problemetic</span></div>;
                    case 'P':
                        return <div><span className="reefer-alert"><img src={TripPending} title="Pending"></img></span><span className='ps-1'> Pending</span></div>;
                    case 'R':
                        return <div><span className="reefer-alert"><img src={TripDeleted} title="Deleted"></img></span><span className='ps-1'> Deleted</span></div>;
                    case 'X':
                        if (deviationFlg == "True")
                            return <div><span className="reefer-alert"><img src={TripCancelDeviation} title="Cancel Deviation"></img></span><span className='ps-1'> Cancel Deviation</span></div>;
                        else
                            return <div><span className="reefer-alert"><img src={TripCancel} title="Cancel"></img></span><span className='ps-1'> Cancel</span></div>;
                    default:
                        return "*No Trip";

                }
            }
            return "*No Trip";
        }
        return "*No Trip";
    }

    static RSSIFormatterGrouping(param) {
        if (param != null && param != undefined) {
            if (param == 1)
                return <div><span className="reefer-alert"><img src={RSSI5} title="5 Bars"></img></span><span className='aggrid-CellSignal'> 5 Bars</span></div>;
            else if (param == 2)
                return <div><span className="reefer-alert"><img src={RSSI4} title="4 Bars"></img></span><span className='aggrid-CellSignal'> 4 Bars</span></div>;
            else if (param == 3)
                return <div><span className="reefer-alert"><img src={RSSI3} title="3 Bars"></img></span><span className='aggrid-CellSignal'> 3 Bars</span></div>;
            else if (param == 4)
                return <div><span className="reefer-alert"><img src={RSSI2} title="2 Bars"></img></span><span className='aggrid-CellSignal'> 2 Bars</span></div>;
            else if (param == 5)
                return <div><span className="reefer-alert"><img src={RSSI1} title="1 Bar"></img></span><span className='aggrid-CellSignal'> 1 Bar</span></div>;
            else
                return <div><span className="reefer-alert"><img src={RSSIUNK} title="Unknown"></img></span><span className='aggrid-CellSignal'> Unknown</span></div>;
        }
    }

    static CommentExistsGrouping(params) {
        if (params != null && params != '-NA-') {
            if (params.toString() == "0")
                return <div><span className="reefer-alert"><img src={GroupChat} title="yes"></img></span><span className='aggrid-CellSignal'> yes</span></div>;
            else
                return "*No Comments";
        }
        else
            return '*No Comments';
    }

    static ChassisBatteryStatusFormatterGrouping(param) {
        if (param != null && param != undefined) {
            switch (param.toString()) {
                case "1":
                    return <div><span className="BatteryIndicator"><img src={batterycritical} title="Critical"></img></span><span className='aggrid-pwr'> Critical</span></div>;
                case "2":
                    return <div><span className="BatteryIndicator"><img src={batterylow} title="Low"></img></span><span className='aggrid-pwr'> Low</span></div>;
                case "3":
                    return <div><span className="BatteryIndicator"><img src={batterynormal} title="Normal"></img></span><span className='aggrid-pwr'> Normal</span></div>;
                case "-1":
                    return '*No BATT';
            }
        }
    }

    static ChassisPwrStateFormatterGrouping(param) {
        if (param != null && param != undefined) {
            switch (param.toString()) {
                case "1":
                    return <div><span className="PlugSolid"><img src={PlugSolid} title="Powered"></img></span><span className='aggrid-pwr'> Powered</span></div>;
                case "2":
                    return <div><span className="PlugSolid"><img src={UnPlug} title="On Battery"></img></span><span className='aggrid-pwr'> On Battery</span></div>;
                case "3":
                    return '*No PWR';
            }
        }
    }
}